<elcia-title [title]="'app.settings' | translate" [iconType]="'setting'"/>
<elcia-tabs [items]="items()"/>
<router-outlet></router-outlet>
